import { render, staticRenderFns } from "./QuoteBuilderOtherLabourHeadingsComponent.vue?vue&type=template&id=2fdbb0b8&scoped=true"
import script from "./QuoteBuilderOtherLabourHeadingsComponent.vue?vue&type=script&lang=js"
export * from "./QuoteBuilderOtherLabourHeadingsComponent.vue?vue&type=script&lang=js"
import style0 from "./QuoteBuilderOtherLabourHeadingsComponent.vue?vue&type=style&index=0&id=2fdbb0b8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdbb0b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fdbb0b8')) {
      api.createRecord('2fdbb0b8', component.options)
    } else {
      api.reload('2fdbb0b8', component.options)
    }
    module.hot.accept("./QuoteBuilderOtherLabourHeadingsComponent.vue?vue&type=template&id=2fdbb0b8&scoped=true", function () {
      api.rerender('2fdbb0b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/quoteBuilder/ItemTypeComponents/quoteBuilderOtherLabour/QuoteBuilderOtherLabourHeadingsComponent.vue"
export default component.exports